<template>
    <div class="row h-25 overflow-hidden">
        <div
            class="col-sm-12 h-100 d-table"
            style="min-height: 100vh; max-height: 100%;margin-top: -100px;"
        >
            <div class="car d card-body d-table-cell align-middle text-center">
                <div class="car d card-block w-100 text-center">
                    <font-awesome-icon :icon="['fas', icon]" class="fa-8x" />
                    <br />
                    <br />
                    <h3>{{ message }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportDefectResult",
    props: ["message", "icon"]
};
</script>

<style scoped></style>
